import { jsx as _jsx } from "react/jsx-runtime";
import NumberItem from './items/NumberItem';
const ListNumbers = ({ selectedFromNumber, dynamicTelephoneNumbersArray, changeFromNumber, onToggle, }) => {
    const listNumber = (number, index) => {
        let className = '';
        let disabled = false;
        if (typeof number !== 'string' && number.outgoing_functionality === false) {
            disabled = true;
            className = 'disabled';
        }
        if (selectedFromNumber &&
            selectedFromNumber.e164_format === number.e164_format) {
            className += ' active';
        }
        return (_jsx(NumberItem, { index: index, disabled: disabled, className: className, changeFromNumber: changeFromNumber, number: number }, index));
    };
    return (_jsx("div", Object.assign({ className: "flags" }, { children: dynamicTelephoneNumbersArray.map(listNumber) })));
};
export default ListNumbers;
